/* global swal */
import angular from 'angular';
import './style.less';
import { get, keyBy } from 'lodash';
import { authorDeliveryMethods } from '@prolaera/library';

export default function(
  $log,
  $scope,
  $q,
  $state,
  $stateParams,
  $transitions,
  Swal,
  ApiClass,
  CoursesClass,
  CategoryClass,
  ProfileClass,
  RegulatorClass
) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  const { profile_uid: profile_profile_uid, company_id } = ProfileClass.profileComplete.profile;
  const profile_uid = $stateParams.employeeID || $stateParams.id || profile_profile_uid;

  $transitions.onExit({ exiting: 'app.author.courses.course.edit' }, () => {
    if ($scope.courseEditorForm && $scope.courseEditorForm.$dirty) {
      $scope.save($scope.formData, $scope.modules, $scope.questions, false);
    }
    return true;
  });

  $scope.reviewOnly = $state.$current.name === 'app.admin.courses.course.review';

  $scope.submit = (course, modules, questions, alert) => {
    if (!course.name) {
      Swal.alert('', 'Please enter a course name.', 'warning');
      return $q.reject({ dismiss: 'Missing course name' });
    }

    if (!course.courseAudience) {
      Swal.alert('', 'Please enter a target audience.', 'warning');
      return $q.reject({ dismiss: 'Missing course target audience' });
    }

    if (!course.sponsor) {
      Swal.alert('', 'Please enter a course sponsor.', 'warning');
      return $q.reject({ dismiss: 'Missing course sponsor' });
    }
    if (!course.instructors || !course.instructors.length) {
      Swal.alert('', 'Please enter a course instructor.', 'warning');
      return $q.reject({ dismiss: 'Missing course instructor' });
    }
    if (!course.form_id) {
      Swal.alert('', 'Please select an evaluation form.', 'warning');
      return $q.reject({ dismiss: 'Missing evaluation form' });
    }
    if (!course.prerequisites) {
      Swal.alert('', 'Please include course prerequisites', 'warning');
      return $q.reject({ dismiss: 'Missing course prerequisites' });
    }
    if (!course.objectives) {
      Swal.alert('', 'Please include course objectives.', 'warning');
      return $q.reject({ dismiss: 'Missing course objectives' });
    }
    if (!course.prep) {
      Swal.alert('', 'Please include course preparation.', 'warning');
      return $q.reject({ dismiss: 'Missing course preparation' });
    }
    if (!course.summary) {
      Swal.alert('', 'Please include course summary.', 'warning');
      return $q.reject({ dismiss: 'Missing course summary' });
    }

    if (!validateCourseCredit(course.hours)) {
      Swal.alert('', 'Please include valid course credit information.', 'warning');
      return $q.reject({ dismiss: 'Missing course credit information.' });
    }

    if (
      course.delivery_method &&
      course.delivery_method.delivery_uid === 0 &&
      (!course.type && course.type !== 'scorm')
    ) {
      const moduleMessage = validateCourseModules(modules);
      if (moduleMessage) {
        Swal.alert('', moduleMessage, 'warning');
        return $q.reject({ dismiss: moduleMessage });
      }

      const questionsMessage = validateCourseQuestions(questions);
      if (questionsMessage) {
        Swal.alert('', questionsMessage, 'warning');
        return $q.reject({ dismiss: questionsMessage });
      }
    }

    return Swal.confirm('Submit Course for Review?', 'Your admin(s) will get notified to review this course')
      .then(() => {
        $scope.save(course, modules, questions, alert);
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  $scope.save = (course, modules, questions, alert) => {
    $scope.laddaBtnSubmit = true;

    const qArr = [updateCourseInfo(course)];

    if (CoursesClass.isCourse(course)) {
      qArr.push(...[updateCourseFinalQuestions(questions), updateCourseModules(modules)]);
    }
    return $q
      .all(qArr)
      .then(() => {
        $scope.laddaBtnSubmit = false;
        if ($scope.courseEditorForm) $scope.courseEditorForm.$setPristine();
        if (!alert) return $q.resolve('updated');
        $state.reload();
        Swal.toast('Updated! Your changes have been saved.');
      })
      .catch(error => {
        $scope.laddaBtnSubmit = false;
        $log.error(error);
        throw error;
      });
  };

  // CHECK COURSE CREDIT INFORMATION
  function validateCourseCredit(hours) {
    if (!hours || !hours.length) return false;

    for (const hour of hours) {
      if (hour.credits === undefined) return false;
      if (hour.category_id === undefined) return false;
      if (hour.subject_area === undefined) return false;
    }

    return true;
  }

  // CHECK COURSE Module INFORMATION
  function validateCourseModules({ arr: modules }) {
    if (!modules || !modules.length) return 'Please include a course module.';

    for (let i = 0; i < modules.length; i++) {
      const mod = modules[i];
      if (!mod.title) return `Please include a valid title for Module: ${i + 1}`;
      if (!mod.description) return `Please include a valid description for Module: ${i + 1}`;
      if (mod.video_status !== 'Uploaded') return `Please include a valid video for Module: ${i + 1}`;
      if (!mod.question) return `Please include a valid description for Module: ${i + 1}`;
    }

    return false;
  }

  // CHECK COURSE CREDIT INFORMATION
  function validateCourseQuestions(questions) {
    if (!questions || !questions.length) return false;

    for (let i = 0; i < questions.length; i++) {
      const question = questions[i];
      if (!question.question) return `Please include a valid question for Final Question: ${i + 1}`;
      if (!question.correct) return `Please include a valid correct answer for Final Question: ${i + 1}`;
    }

    return false;
  }

  // SAVE COURSE MODULES
  function updateCourseModules({ arr, obj }) {
    // TODO: This needs to be refactor
    function updateModule(moduleId) {
      if (!moduleId || !obj[moduleId]) return {};
      const updatedQuestion = {
        module_id: obj[moduleId].module_id,
        title: obj[moduleId].title,
        description: obj[moduleId].description,
        quiz_id: moduleId,
        question_id: obj[moduleId].question_id,
        question: obj[moduleId].question,
        correct: obj[moduleId].correct,
        answers: {
          a: obj[moduleId].answers.a,
          b: obj[moduleId].answers.b,
          c: obj[moduleId].answers.c,
          d: obj[moduleId].answers.d
        },
        reasons: {
          a: obj[moduleId].reasons.a,
          b: obj[moduleId].reasons.b,
          c: obj[moduleId].reasons.c,
          d: obj[moduleId].reasons.d
        }
      };
      // TODO: This isn't restful and needs to be fix with the database cleanup
      return ApiClass.coursesIdTypeTypeIdPatch(
        { id: moduleId, type: 'questions', type_id: updatedQuestion.question_id },
        { question: updatedQuestion },
        { queryParams: { manage: true } }
      );
    }

    const modulePromises = arr.map(({ module_id }) => updateModule(module_id, true));
    return $q.all(modulePromises);
  }

  // SAVE FINAL QUESTIONS
  function updateCourseFinalQuestions(questions) {
    function updateFinal(question) {
      const updatedQuestion = {
        quiz_id: question.quiz_id,
        question_id: question.question_id,
        question: question.question,
        correct: question.correct,
        answers: {
          a: question.answers.a,
          b: question.answers.b,
          c: question.answers.c,
          d: question.answers.d
        }
      };
      return ApiClass.coursesIdTypeTypeIdPatch(
        { id: $scope.courseData.course_id, type: 'questions', type_id: question.question_id },
        { question: updatedQuestion },
        { queryParams: { manage: true } }
      );
    }

    const qArr = questions.map(question => updateFinal(question));

    return $q.all(qArr);
  }

  // Update Course Editor component info
  function updateCourseInfo(course) {
    course.hours_basic = course.formData.modifiedStates.reduce((obj, state) => {
      obj[state.reg_id] = state.hours;
      return obj;
    }, {});

    const { credits, category_id } = get(course, 'hours[0]', {});

    return ApiClass.coursesIdPatch(
      { id: $stateParams.courseId, manage: true },
      {
        course: {
          course_id: $stateParams.courseId,
          company_id: course.company_id,
          name: course.name,
          by: course.by,
          hours: course.hours,
          hours_basic: course.hours_basic,
          sponsor: course.sponsor,
          credits: Number(credits),
          category_id,
          expiration_date: course.expiration_date,
          form_id: course.form_id,
          level: course.level,
          instructors: course.instructors,
          irs_approval_number: course.irs_approval_number,
          courseAudience: course.courseAudience,
          prerequisites: course.prerequisites,
          delivery_method: Number(course.delivery_method.delivery_uid),
          summary: course.summary,
          payee: course.payee,
          objectives: course.objectives,
          prep: course.prep,
          vendor_id: course.vendor_id,
          price: course.price,
          priceTerms: course.priceTerms,
          priceText: course.priceText,
          priceType: course.priceType,
          productImageUrl: course.productImageUrl,
          modules: course.modules,
          tags: course.tags,
          url: course.url
        }
      }
    );
  }

  function activate() {
    $log.log('Activating course info view');

    $scope.loaded = false;
    if ($scope.error) $scope.error.status = false;

    $q.all([
      CategoryClass.loadCategories(),
      ApiClass.coursesIdGet({ id: $stateParams.courseId }, {}, { queryParams: { manage: true } }),
      ApiClass.companiesIdGet({ manage: true, id: company_id }, null, {
        queryParams: {
          evaluationForms: true,
          payees: true,
          sponsors: true,
          vendors: true
        }
      }),
      ProfileClass.profileGet(profile_uid),
      RegulatorClass.loadRegulators()
    ])
      .then(
        ([
          categoryData,
          courseResponse,
          {
            data: { evaluationForms, payees, sponsors, vendors }
          },
          profile,
          regulators
        ]) => {
          const reviewForms = {
            arr: evaluationForms,
            obj: keyBy(evaluationForms, 'form_id')
          };
          const course = courseResponse ? courseResponse.data.course : {};
          $scope.sponsors = sponsors;
          $scope.vendors = vendors;
          $scope.payees = payees;
          $scope.categoryData = categoryData;
          $scope.deliveryMethodData = authorDeliveryMethods;
          $scope.questions = course.questionsArr;
          $scope.material = course.materials;
          $scope.modules = { arr: course.modulesArr, obj: keyBy(course.modulesArr, 'module_id') };
          $scope.adminReviews = angular.copy(reviewForms);
          $scope.profile = profile;
          $scope.regulators = regulators;
          $scope.courseData = angular.copy(course);
          $scope.formData = course;
          $scope.loaded = true;
        }
      )
      .catch(error => {
        $log.error(error);
        $scope.loaded = true;
        $scope.error.status = true;
        $scope.error.refresh = activate;
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/author/course/index.js